/**
 * Avviso sui recapiti del pre-accesso, dal prototipo: chi scrive non è stato autenticato. Lo usa il
 * dettaglio e lo riusa il composer di #5 (PRD-004 US-4); se ha lasciato un numero, lo mostra.
 */
export function declaredContactsNotice(phone: string | null): string {
  const base =
    "Segnalazione aperta senza accesso: indirizzo e struttura li ha scritti chi segnala, nessuno li ha verificati. Prima di intervenire sull'utenza, accertati che sia davvero chi dice di essere";
  return phone ? `${base}: ha lasciato il numero ${phone}.` : `${base}.`;
}
